<ion-row class="business-search-products-row">
  <ion-col size="12">
    <ion-searchbar class="business-searchbar" show-clear-button="focus" placeholder="Buscar..."
      (ionInput)="onInput($event)" #ionInputSearchBar></ion-searchbar>
  </ion-col>
</ion-row>